export default function YoutubeWidget(){
    return (
      <div>
        <div className="lg:mt-8">
        <iframe width="100%" height="200" src="https://www.youtube.com/embed/JjxJlMWPI6U" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen loading="lazy"></iframe>
        </div>
      </div>
    )
  }

